import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { booleanParamSchema } from '../utils';
import { ZGiftCardSelect, ZSupportedGiftCardProviders } from './models';

const c = initContract();

export const adminGiftCardIntegrationContract = c.router(
  {
    getAvailableCampaigns: {
      method: 'GET',
      path: '/:provider/campaigns',
      pathParams: z.object({
        provider: ZSupportedGiftCardProviders,
      }),
      responses: {
        200: z.string().array(),
      },
    },

    getGiftCards: {
      method: 'GET',
      path: '/gift-cards',
      query: z.object({
        playerId: z.string().optional(),
        expired: booleanParamSchema.optional(),
        limit: z.coerce.number().optional(),
        page: z.coerce.number().optional(),
      }),
      responses: {
        200: z.object({
          data: ZGiftCardSelect.array(),
          totalPages: z.number(),
        }),
      },
    },

    awardFreeGiftCard: {
      method: 'POST',
      path: '/gift-card',
      body: z.object({
        provider: ZSupportedGiftCardProviders,
        playerId: z.string(),
        code: z.string(),
      }),
      responses: {
        200: ZGiftCardSelect.pick({
          provider: true,
          code: true,
          redeemCode: true,
          redeemUrl: true,
          expiresAt: true,
        }),
        400: z.object({
          message: z.string(),
        }),
        502: z.object({
          message: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/admin',
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
